import { render, staticRenderFns } from "./TextRecogniser.vue?vue&type=template&id=9c8231e4&scoped=true&"
import script from "./TextRecogniser.vue?vue&type=script&lang=js&"
export * from "./TextRecogniser.vue?vue&type=script&lang=js&"
import style0 from "./TextRecogniser.vue?vue&type=style&index=0&id=9c8231e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8231e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VProgressLinear,VRow,VSelect})
